import { xhr, XHRResponse, getErrorStatusDescription } from 'request-light';

export class NominatimService {
  targetUrl: string = 'https://nominatimv2.photoprintit.com/search';

  /**
   * https://developer.mozilla.org/en-US/docs/Web/API/Request
   */
  executeRequest(param: string, callback: CallableFunction) {
    // https://nominatim.org/release-docs/develop/api/Search/
    const requestURL = encodeURI(this.targetUrl + param);
    const options = {
      method: 'get',
      url: requestURL,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
    };

    xhr(options).then(
      (response) => {
        const responseObj = JSON.parse(response.responseText);
        callback(responseObj);
      },
      (error: XHRResponse) => {
        throw new Error(error.responseText || getErrorStatusDescription(error.status) || error.toString());
      },
    );
  }
}

export const NOMINATIM = new NominatimService();
